// extracted by mini-css-extract-plugin
export default {"container":"CourseHeader_container__YxZlP","image":"CourseHeader_image__cqtGk"};